import { createStyles } from '@mantine/emotion';
import { rem } from '@mantine/core';

export default createStyles((theme) => ({
  input: {
    '&:not(:disabled)': {
      cursor: 'pointer',

      '&::selection': {
        backgroundColor: 'transparent',
      },
    },
  },

  dropdown: {
    padding: rem(4),
  },
}));
